import { render } from "./UnarchiveGoalPrompt.vue?vue&type=template&id=390ba248&scoped=true"
import script from "./UnarchiveGoalPrompt.vue?vue&type=script&lang=js"
export * from "./UnarchiveGoalPrompt.vue?vue&type=script&lang=js"

import "./UnarchiveGoalPrompt.vue?vue&type=style&index=0&id=390ba248&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-390ba248"

export default script